export default __webpack_public_path__ + "static/media/3.1d9b5a12.jpg";